// Lightweight AJAX wrapper for BuddyPress compatibility modules
// Provides a single `postAction(action, data)` helper that returns a Promise.
export async function postAction(action, data = {}, opts = {}) {
    // If data is FormData, we'll append action directly to it and let
    // the underlying transport handle content-type/boundary.
    const isFormData = (typeof FormData !== 'undefined') && (data instanceof FormData);

    // If jQuery is available, prefer its ajax (keeps parity with existing code)
    if (typeof window !== 'undefined' && window.jQuery) {
        return new Promise((resolve, reject) => {
            if (isFormData) {
                // append action to FormData and pass through
                data.append('action', action);
                jQuery.ajax(Object.assign({
                    url: typeof Metafans_JS !== 'undefined' ? Metafans_JS.ajaxurl : '/wp-admin/admin-ajax.php',
                    type: 'POST',
                    data: data,
                    processData: false,
                    contentType: false,
                    success: (res) => resolve(res),
                    error: (xhr, status, err) => reject(err || status),
                }, opts));
                return;
            }

            const payload = Object.assign({}, data, { action });
            jQuery.ajax(Object.assign({
                url: typeof Metafans_JS !== 'undefined' ? Metafans_JS.ajaxurl : '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: payload,
                success: (res) => resolve(res),
                error: (xhr, status, err) => reject(err || status),
            }, opts));
        });
    }

    // Fallback to fetch
    const ajaxurl = (typeof Metafans_JS !== 'undefined' && Metafans_JS.ajaxurl) ? Metafans_JS.ajaxurl : '/wp-admin/admin-ajax.php';

    if (isFormData) {
        // ensure action is present
        data.append('action', action);

        const res = await fetch(ajaxurl, {
            method: 'POST',
            credentials: 'same-origin',
            body: data,
        });

        const text = await res.text();
        try {
            return JSON.parse(text);
        } catch (e) {
            return text;
        }
    }

    const payload = Object.assign({}, data, { action });
    const form = new URLSearchParams();
    Object.keys(payload).forEach((k) => {
        if (payload[k] === undefined) return;
        form.append(k, payload[k]);
    });

    const res = await fetch(ajaxurl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: form.toString(),
    });

    // try parse JSON, but fall back to raw text
    const text = await res.text();
    try {
        return JSON.parse(text);
    } catch (e) {
        return text;
    }
}

export default {
    postAction,
};
